// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom"; // <-- Re-enabled
// import "./LandingPage.css";
// import Navbar from "./Navbar";
// import Footer from "./Footer";

// /* ---------------- Header Component ---------------- */
// // ... The Header component code has been removed from here ...

// // ---------- Hero ----------
// const Hero = ({ onBrowseClick }) => ( // <-- Prop added
//   <div className="landing-page hero">
//     <section className="hero-section">
//       <div className="hero-content">
//         <h1 className="hero-title">
//           Discover the Future of{" "}
//           <span className="hero-highlight">Aisle Agent</span>
//         </h1>
//         <p className="hero-description">
//           Browse thousands of specialized AI agents designed to automate your
//           work, enhance productivity, and solve complex problems across every
//           industry.
//         </p>
//         <div className="hero-buttons">
//           {/* MODIFIED: Added onClick handler */}
//           <button className="btn-primary" onClick={onBrowseClick}>
//             Browse Agents ➡
//           </button>
//           <button className="btn-secondary">Learn More</button>
//         </div>

//         <div className="hero-stats">
//           <div className="hero-stat">
//             <span className="hero-stat-number" style={{ color: "#f9a8d4" }}>
//               25+
//             </span>
//             <span className="hero-stat-label">Aisle Agents</span>
//           </div>
//           <div className="hero-stat">
//             <span className="hero-stat-number" style={{ color: "#fde047" }}>
//               200+
//             </span>
//             <span className="hero-stat-label">Tasks Completed</span>
//           </div>
//           <div className="hero-stat">
//             <span className="hero-stat-number" style={{ color: "#86efac" }}>
//               99.9%
//             </span>
//             <span className="hero-stat-label">Uptime</span>
//           </div>
//         </div>
//       </div>
//     </section>
//   </div>
// );

// // ---------- Featured Agents ----------
// // const FeaturedAgents = () => (
// //   <section className="landing-page featured-agents-section">
// //     <h2 className="featured-title">Featured Agents</h2>
// //     <div className="agent-cards-row">
// //       {[
// //         {
// //           name: "ProductivityPro AI",
// //           rating: 4.8,
// //           reviews: 4322,
// //           badges: ["Productivity", "Workflow"],
// //           price: "$3.99",
// //           free: false,
// //         },
// //         {
// //           name: "ContentCraft Studio",
// //           rating: 4.9,
// //           reviews: 3102,
// //           badges: ["Content", "Writing"],
// //           price: "Free",
// //           free: true,
// //         },
// //         {
// //           name: "DesignGenius AI",
// //           rating: 4.7,
// //           reviews: 3888,
// //           badges: ["Design", "UI/UX"],
// //           price: "$2.50",
// //           free: false,
// //         },
// //       ].map((agent, idx) => (
// //         <div className="agent-card" key={idx}>
// //           <div className="agent-card-header">
// //             <span className="agent-name">{agent.name}</span>
// //             <span className="agent-badges">
// //               {agent.badges.map((b) => (
// //                 <span className="agent-badge" key={b}>
// //                   {b}
// //                 </span>
// //               ))}
// //             </span>
// //           </div>
// //           <div className="agent-card-rating">
// //             ★ {agent.rating} ({agent.reviews})
// //           </div>
// //           <div className="agent-card-footer">
// //             <span className={`agent-card-price ${agent.free ? "free" : ""}`}>
// //               {agent.price}
// //             </span>
// //             <button className="agent-detail-btn">View Details</button>
// //           </div>
// //         </div>
// //       ))}
// //     </div>
// //   </section>
// // );

// // ---------- Filter Sidebar ----------
// // const FilterSidebar = ({
// //   onCategoryChange,
// //   onPriceRangeChange,
// //   selectedCategory,
// // }) => {
// //   const [isCategoryOpen, setIsCategoryOpen] = useState(true);
// //   const [isPriceOpen, setIsPriceOpen] = useState(true);
// //   const [isRatingOpen, setIsRatingOpen] = useState(true);

// //   const categories = [
// //     { id: "all", name: "All Categories", count: 5234 },
// //     { id: "productivity", name: "Productivity", count: 1203 },
// //     { id: "marketing", name: "Marketing", count: 892 },
// //     { id: "development", name: "Development", count: 756 },
// //     { id: "design", name: "Design", count: 645 },
// //     { id: "analytics", name: "Analytics", count: 534 },
// //     { id: "customer-service", name: "Customer Service", count: 421 },
// //     { id: "content", name: "Content Creation", count: 387 },
// //     { id: "finance", name: "Finance", count: 298 },
// //   ];

// //   const priceRanges = [
// //     { label: "Free", min: 0, max: 0 },
// //     { label: "$1 - $10", min: 1, max: 10 },
// //     { label: "$11 - $50", min: 11, max: 50 },
// //     { label: "$51 - $100", min: 51, max: 100 },
// //     { label: "$100+", min: 101, max: 9999 },
// //   ];

// //   return (
// //     <div className="landing-page filter-sidebar">
// //       <div className="filter-header">⚙ Filters</div>

// //       <div className="filter-section">
// //         <button onClick={() => setIsCategoryOpen(!isCategoryOpen)}>
// //           Categories {isCategoryOpen ? "▲" : "▼"}
// //         </button>
// //         {isCategoryOpen &&
// //           categories.map((c) => (
// //             <label key={c.id}>
// //               <input
// //                 type="radio"
// //                 name="category"
// //                 value={c.id}
// //                 checked={selectedCategory === c.id}
// //                 onChange={() => onCategoryChange(c.id)}
// //               />
// //               {c.name} <span>({c.count})</span>
// //             </label>
// //           ))}
// //       </div>

// //       <div className="filter-section">
// //         <button onClick={() => setIsPriceOpen(!isPriceOpen)}>
// //           Price Range {isPriceOpen ? "▲" : "▼"}
// //         </button>
// //         {isPriceOpen &&
// //           priceRanges.map((p) => (
// //             <label key={p.label}>
// //               <input
// //                 type="checkbox"
// //                 onChange={() => onPriceRangeChange(p.min, p.max)}
// //               />
// //               {p.label}
// //             </label>
// //           ))}
// //       </div>

// //       <div className="filter-section">
// //         <button onClick={() => setIsRatingOpen(!isRatingOpen)}>
// //           Rating {isRatingOpen ? "▲" : "▼"}
// //         </button>
// //         {isRatingOpen &&
// //           [5, 4, 3, 2, 1].map((r) => (
// //             <label key={r}>
// //               <input type="checkbox" />
// //               {[...Array(r)].map((_, i) => (
// //                 <span key={i} className="star yellow">
// //                   ★
// //                 </span>
// //               ))}
// //               {[...Array(5 - r)].map((_, i) => (
// //                 <span key={i} className="star gray">
// //                   ★
// //                 </span>
// //               ))}
// //               {r}+ stars
// //             </label>
// //           ))}
// //       </div>
// //     </div>
// //   );
// // };

// // ---------- All Agents ----------
// // const AllAgents = () => (
// //   <section className="landing-page all-agents-section">
// //     <div className="all-agents-header">
// //       <h2>All Agents</h2>
// //       <input
// //         type="text"
// //         className="agents-search"
// //         placeholder="Search agents..."
// //       />
// //     </div>
// //     <div className="all-agents-grid">{/* cards would be mapped here */}</div>
// //   </section>
// // );

// /* ---------------- Footer Component ---------------- */
// // const Footer = () => (
// //   <footer
// //     style={{
// //       width: "100%",
// //       backgroundColor: "#1a1a2e",
// //       color: "#fff",
// //       textAlign: "center",
// //       padding: "20px 0",
// //       marginTop: "auto",
// //     }}
// //   >
// //     <div
// //       style={{
// //         maxWidth: "1200px",
// //         margin: "0 auto",
// //         padding: "0 20px",
// //       }}
// //     >
// //       <p style={{ margin: 0, fontSize: "14px" }}>
// //         Powered By{" "}
// //         <span style={{ fontWeight: "bold", color: "#8b5cf6" }}>
// //           SLT Digital Lab
// //         </span>{" "}
// //         | @2025
// //       </p>
// //     </div>
// //   </footer>
// // );
// // ---------- Main Landing Page ----------
// const LandingPageMain = () => {
//   const navigate = useNavigate(); // <-- ADDED: Initialize the hook

//   const handleBrowseAgentsClick = () => {
//     navigate("/prelogin");
//   };

//   // const [selectedCategory, setSelectedCategory] = useState("all");
//   // const handleCategoryChange = (category) => setSelectedCategory(category);
//   // const handlePriceRangeChange = (min, max) =>
//   //   console.log("Price Range:", min, max);
//   // ADDED: Create the handler function to pass down

//   return (
//     <div
//       style={{
//         // width: "100vw",
//         // display: "flex",
//         // flexDirection: "column",
//         // overflow: "hidden",
        
//       }}
//     >
//       <div
//         style={{
//           // background: "linear-gradient(135deg, #1e003d, #34006f)",
//           // minHeight: "100vh",
//           width: "100%",
//           fontFamily: "Arial, sans-serif",
//           color: "#fff",
//           // paddingTop: "100px",
//           // padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <Navbar /> {/* <-- CHANGED THIS from <Header /> */}
//         {/* MODIFIED: Pass the handler prop to Hero */}
//         <Hero onBrowseClick={handleBrowseAgentsClick} />
//         {/* <FeaturedAgents /> */}
//         <div className="landing-main">
//           {/* <FilterSidebar
//             selectedCategory={selectedCategory}
//             onCategoryChange={handleCategoryChange}
//             onPriceRangeChange={handlePriceRangeChange}
//           /> */}
//           {/* <div className="main-content">
//             <AllAgents />
//           </div> */}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default LandingPageMain;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./LandingPage.css";
// // Assuming Navbar and Footer components exist and are necessary
// import Navbar from "./Navbar";
// import Footer from "./Footer";

// // ---------- Hero Component ----------
// const Hero = ({ onBrowseClick }) => (
//   <div className="landing-page hero">
//     <section className="hero-section">
//       <div className="hero-content">
//         <h1 className="hero-title">
//           Discover the Future of{" "}
//           <span className="hero-highlight">Aisle Agent</span>
//         </h1>
//         <p className="hero-description">
//           Browse thousands of specialized AI agents designed to automate your
//           work, enhance productivity, and solve complex problems across every
//           industry.
//         </p>
//         <div className="hero-buttons">
//           {/* Added onClick handler to the primary button */}
//           <button className="btn-primary" onClick={onBrowseClick}>
//             Browse Agents ➡
//           </button>
//           <button className="btn-secondary">Learn More</button>
//         </div>

//         <div className="hero-stats">
//           <div className="hero-stat">
//             <span className="hero-stat-number" style={{ color: "#f9a8d4" }}>
//               25+
//             </span>
//             <span className="hero-stat-label">Aisle Agents</span>
//           </div>
//           <div className="hero-stat">
//             <span className="hero-stat-number" style={{ color: "#fde047" }}>
//               200+
//             </span>
//             <span className="hero-stat-label">Tasks Completed</span>
//           </div>
//           <div className="hero-stat">
//             <span className="hero-stat-number" style={{ color: "#86efac" }}>
//               99.9%
//             </span>
//             <span className="hero-stat-label">Uptime</span>
//           </div>
//         </div>
//       </div>
//     </section>
//   </div>
// );

// // ---------- Main Landing Page Component ----------
// const LandingPageMain = () => {
//   const navigate = useNavigate();

//   const handleBrowseAgentsClick = () => {
//     // Navigates the user to the "/prelogin" route
//     navigate("/prelogin");
//   };

//   return (
//     <div
//       style={{
//         width: "100%",
//         fontFamily: "Arial, sans-serif",
//         color: "#fff",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <Navbar />
//       {/* Pass the handler prop to Hero */}
//       <Hero onBrowseClick={handleBrowseAgentsClick} />
//       <div className="landing-main">
//         {/* Main content area, currently empty after removing AllAgents */}
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default LandingPageMain;

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

// ---------- Hero Component ----------
const Hero = ({ onBrowseClick }) => (
  <section className="hero-section">
    <div className="hero-container">
      <div className="hero-content">

        {/* Badge */}
        <div className="hero-badge">
          <span className="hero-badge-dot" />
          Now live — 25+ AI Agents
        </div>

        {/* Headline */}
        <h1 className="hero-title">
          Discover the Future of{" "}
          <br />
          <span className="hero-highlight">Aisle Agent</span>
        </h1>

        {/* Description */}
        <p className="hero-description">
          Browse thousands of specialized AI agents designed to automate your
          work, enhance productivity, and solve complex problems across every
          industry.
        </p>

        {/* CTA Buttons */}
        <div className="hero-buttons">
          <button className="btn-primary" onClick={onBrowseClick}>
            Browse Agents <span style={{ fontSize: "1.1em" }}>→</span>
          </button>
          <button className="btn-secondary">Learn More</button>
        </div>

        {/* Stats */}
        <div className="hero-stats">
          <div className="hero-stat">
            <span className="hero-stat-number" style={{ color: "#f9a8d4" }}>25+</span>
            <span className="hero-stat-label">Aisle Agents</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-number" style={{ color: "#fde047" }}>200+</span>
            <span className="hero-stat-label">Tasks Completed</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-number" style={{ color: "#86efac" }}>99.9%</span>
            <span className="hero-stat-label">Uptime</span>
          </div>
        </div>

      </div>
    </div>
  </section>
);

// ---------- Main Landing Page ----------
const LandingPageMain = () => {
  const navigate = useNavigate();

  // Lock scroll only while on landing page, restore when leaving
  useEffect(() => {
    document.body.classList.add("landing-no-scroll");
    return () => {
      document.body.classList.remove("landing-no-scroll");
    };
  }, []);

  const handleBrowseAgentsClick = () => {
    navigate("/prelogin");
  };

  return (
    <div className="landing-page">
      <Navbar />
      <Hero onBrowseClick={handleBrowseAgentsClick} />
      <div className="landing-main" />
      <Footer />
    </div>
  );
};

export default LandingPageMain;